exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Iphx{float:left;margin:0 .3em .3em 0;font-size:14px;color:#888;font-weight:400}._3909O{margin:0;height:18px;list-style-type:none;padding:0}", ""]);

// exports
exports.locals = {
	"itemListElement": "_3Iphx",
	"olNavigationLink": "_3909O"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/BreadcrumbsLinks/BreadcrumbsLinks.css
// module id = 1860
// module chunks = 0 1 20 21 22